<ul>
    <li *ngFor="let rule of validationRules" [ngClass]="{ 'met': rule.isMet, 'notmet':!rule.isMet }">
        {{ rule.rule }}
        <img *ngIf="rule.isMet!==false" loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/6e46e582-82fb-4f16-a811-9abe7d12918b?"
            class="img-succes-ticks" />
    </li>
</ul>